import styled from "styled-components";
import ControlUI from "../components/molecules/ControlUI";
import RepetitionPicker from "../components/molecules/RepetitionPicker";
import ApplicationForm from "../components/organisms/ApplicationForm";
import Accordion from "../components/molecules/Accordion";
import ColorSchemePicker from "../components/molecules/ColorSchemePicker";
import PresetPicker from "../components/molecules/PresetPicker";
import ApplicationOneHolder from "../components/organisms/ApplicationOneHolder";
import ChatGPTWidget from "../components/organisms/ChatGPTWidget";
import Footer from "../components/molecules/Footer";

const Holder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 4rem 2rem;

  display: grid;
  grid-template-columns: 5fr 3fr;
`;

const ApplicationHolder = styled.div`
  height: 100%;
  padding: 1rem;
`;

const Sidebar = styled.div`
  height: 100%;
  overflow: auto;
`;

const MobileOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  @media( ${props => props.theme.breakpoints.lg} ) {
    display: none;
  }
  p {
    margin: 0;
    color: var(--white);
    background-color: var(--color-6);
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    font-weight: bold;
    ${(props) => props.theme.fluidType(1)};
    transform: rotate(-10deg);
    width: 20rem;
  }
`;

const FVSTool = () => {
  return (
    <>
      <MobileOverlay>
        <p>Sorry, this tool is not yet available on small screens</p>
      </MobileOverlay>
      <Holder>
        <ApplicationHolder>
          <ApplicationOneHolder />
        </ApplicationHolder>
        <Sidebar>
          <Accordion
            step={1}
            title="Color Scheme"
            description="Choose a colour scheme"
          >
            <ColorSchemePicker />
          </Accordion>
          <Accordion
            step={2}
            title="Control component"
            description="Change this to alter your chosen application"
          >
            <ControlUI />
          </Accordion>
          <Accordion
            step={3}
            title="SELECT REPETITION TYPE"
            description="Pick a type of repetition to be used in your applications"
          >
            <RepetitionPicker />
          </Accordion>
          <Accordion
            step={4}
            title="adjust Application"
            description="Adjust its unique variations to finalise your design"
          >
            <ApplicationForm />
          </Accordion>
          <Accordion
            step={5}
            title="Explore some presets"
            description="See some presets that we think are fun"
          >
            <PresetPicker />
          </Accordion>
          <Accordion
            ai={true}
            step={6}
            title="Use AI"
            description="Enter a prompt to get an AI-generated design"
          >
            <ChatGPTWidget />
          </Accordion>
        </Sidebar>
      </Holder>
      <Footer />
    </>
  );
};

export default FVSTool;
